export default {
    state: {
        hasVFairs: false,
        hackEnabled: false,
    },
    getters: {
        getHasVFairs: state => () => state.hasVFairs,
        getHackEnabled: state => () => state.hackEnabled,
    },
    mutations: {
        setHasVFairs: (state, bool) => {
            state.hasVFairs = bool;
        },
        setHackEnabled: (state, enabled) => {
            state.hackEnabled = enabled;
        },
    },
};
